import { adminComponents } from './admin.js';
import { countersinkComponents } from './countersink.js';
import { customMaterialComponents } from './custom-material.js';
import { featureSettingComponents } from './feature-setting.js';
import { presetCategoryComponents } from './preset-category.js';
import { presetComponents } from './preset.js';
import { recipeComponents } from './recipe.js';
export const adminGeneratedComponents = [
    ...featureSettingComponents,
    ...presetComponents,
    ...adminComponents,
    ...customMaterialComponents,
    ...countersinkComponents,
    ...presetCategoryComponents,
    ...recipeComponents
];

//# sourceMappingURL=index.js.map